export const checkMultiples = (baggage, type, unit) => {
  if (!baggage) return false
  if (!Array.isArray(baggage)) return false
  const tmp = []
  for (let i = 0; i < baggage.length; i++) {
    if (
      baggage[i].baggageItem &&
      baggage[i].baggageItem.type === type &&
      baggage[i].baggageItem[unit]
    ) {
      if (tmp.indexOf(baggage[i].baggageItem[unit]) === -1) {
        tmp.push(baggage[i].baggageItem[unit])
      }
    }
  }

  return tmp.length > 1
}

export const checkIfConsistent = (items) => {
  const pieces = []
  const baggage = []
  for (let i = 0; i < items.length; i++) {
    if (items[i] && items[i].baggageItem) {
      pieces.push(items[i].baggageItem.pieces)
      baggage.push(items[i].baggageItem.weight)
    }
  }
  const _ret =
    pieces.every((val, i, arr) => val === arr[0]) &&
    baggage.every((val, i, arr) => val === arr[0]) // tru
  return _ret
}

export const convertPiece = (number) => {
  const pieces = {
    '0PC': 'Zero',
    '1PC': 'One',
    '2PC': 'Two',
    '3PC': 'Three',
    '4PC': 'Four',
    '5PC': 'Five',
    '6PC': 'Six',
    '7PC': 'Seven',
    NOL: 'See notes',
    LIM: 'See notes',
  }
  return pieces[number]
}

export const pieceLabel = (pieces) => {
  if (pieces === 'LIM' || pieces === 'NOL') {
    return 'in total'
  }
  return 'each'
}

export const convertBaggage = (_dim, _dimG, _use) => {
  if (_use) {
    return _dimG
  }
  return _dim
}
